module.exports = __webpack_public_path__ + "static/media/wellness-web-3.3dfffbb5.jpg";